import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from "rxjs/Observable";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';

import * as globalConst from './../../../../constants';

@Injectable()
export class AttachmentListService {

	private apiUrl = globalConst.baseAPI;

	constructor(private http: Http) { }

	searchAttachment(token, descricao, status, orderby, sort, page) {

		var statusFilter = "";
		if (status != "") statusFilter = "and Ativo eq " + status;

		page = page * globalConst.paginationSkip;

		return this.http
			.get(this.apiUrl + "documents/v1/getattachment?$orderby=" + orderby + " " + sort + "&$top=" + globalConst.paginationSkip + "&$skip=" + page + "&$filter=startswith(tolower(Descricao),'" + descricao.toLowerCase() + "') " + statusFilter, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	searchAttachmentByCategory(token, CategoriaDocumento, status, orderby, sort, page) {
		var statusFilter = "";
		if (status != "") statusFilter = "and Ativo eq " + status;
		return this.http
			.get(this.apiUrl + "documents/v1/getattachment?$orderby=" + orderby + " " + sort + "&$filter=CategoriaDocumento eq " + Number(CategoriaDocumento)+ "" + statusFilter, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}


}



// WEBPACK FOOTER //
// ./src/app/attachment/service/attachment-list/attachment-list.service.ts